import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `commercial--marketing--sites--index--dashboard`
  }

  doSitesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-6 pr-1" data-${this.controllerName}-target="list" data-controller="commercial--marketing--sites--index--list"></div>
                  <div class="col-6 pl-1" data-${this.controllerName}-target="view" data-controller="commercial--marketing--sites--index--save commercial--marketing--sites--index--show"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`commercial--marketing--sites--index--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`commercial--marketing--sites--index--submenu`).dashboardToggleBtn(`DASHBOARD`)

      controller.getControllerByIdentifier(`commercial--marketing--sites--index--list`).permission = this.permission
      controller.getControllerByIdentifier(`commercial--marketing--sites--index--show`).permission = this.permission
      controller.getControllerByIdentifier(`commercial--marketing--sites--index--save`).permission = this.permission

      controller.getControllerByIdentifier(`commercial--marketing--sites--index--list`).doIndexListHtml()
      controller.getControllerByIdentifier(`commercial--marketing--sites--index--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
